import React, { useEffect } from 'react';
import {
  getSubComponent,
  getSubComponentStyles,
} from '../../utils/react.utils';
import Container from '../containers/container';
import { VStack } from './stack.layout';

// Needs to be standardized

type InfoLayoutProps = {
  children: any;
  showInfo: boolean;
  close: Function;
};

type SubComponentNames = 'Aside' | 'Content';

const styles = {
  cover: {
    mobile: 'mobile:w-full h-full mobile:top-0',
    'tablet-lg':
      'tablet-lg:block w-[calc(100%-450px)] border-l border-dark-gray fixed h-screen top-0 bg-black/70',
  },
  card: {
    mobile: 'mobile:w-full mobile:top-0 mobile:bg-[#08080D]',
    'tablet-lg':
      'tablet-lg:block tablet-lg:w-[450px] tablet-lg:border-l border-dark-gray tablet-lg:top-0 tablet-lg:bottom-0 tablet-lg:bg-[#171718]',
  },
};

// py-2 mobile:px-3 tablet-lg:px-5

function InfoLayout(props: InfoLayoutProps) {
  const { children, showInfo } = props;

  const Aside = getSubComponent<SubComponentNames>(children, 'Aside');
  const Content = getSubComponent<SubComponentNames>(children, 'Content');

  const asideClassName = getSubComponentStyles(Aside);
  const contentClassName = getSubComponentStyles(Content);

  useEffect(() => {
    showInfo
      ? document.querySelector('body')?.classList.add('no-scroll')
      : document.querySelector('body')?.classList.remove('no-scroll');
  }, [showInfo]);

  return (
    <div className="w-full h-full relative">
      <div className={contentClassName}>{Content}</div>
      {showInfo && (
        <Container extensions="flex flex-col">
          <div
            onClick={() => props.close()}
            className={`fixed z-[100] ${styles.cover['tablet-lg']} ${styles.cover.mobile}`}
          />
          <div
            className={`fixed z-[100] right-0 ${styles.card['tablet-lg']} ${styles.card.mobile} `}
          >
            <VStack
              extensions={`mobile:h-screen tablet-lg:h-full ${asideClassName}`}
              gap="sm"
            >
              {Aside}
            </VStack>
          </div>
        </Container>
      )}
    </div>
  );
}

type SCProps = {
  className?: string;
  children: any;
};

const Content = (props: SCProps) => props.children;
const Aside = (props: SCProps) => props.children;

Content.displayName = 'Content';
Aside.displayName = 'Aside';

InfoLayout.Content = Content;
InfoLayout.Aside = Aside;

export default InfoLayout;
